var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.9394 12.0001L7.46973 4.53039L8.53039 3.46973L17.0607 12.0001L8.53039 20.5304L7.46973 19.4697L14.9394 12.0001Z","fill":"black"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
